import { Link } from "react-router-dom";
import "./index.css";

export default function ContactModal({ triggerClass = "btn-outline" }) {
    return (
        <>
            <Link to="/sales" style={{ textDecoration: "none" }}>
                <div className={triggerClass}>
                    Contact Us
                </div>
            </Link>
        </>
    );
}
